module.exports = __webpack_public_path__ + "static/media/CTLA_6-540w.dea8afb4.webp";